interface FilterGroupProps {
  title: string;
  options: (string | number)[];
  selected: (string | number)[];
  onToggle: (value: string | number) => void;
}

function FilterGroup({ title, options, selected, onToggle }: FilterGroupProps) {
  return (
    <div className="mb-6">
      <h4 className="font-heading font-semibold text-foreground-950 text-sm mb-3">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt);
          return (
            <button
              key={String(opt)}
              type="button"
              onClick={() => onToggle(opt)}
              className={`px-3 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900 border border-background-200'
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export interface FilterState {
  genres: string[];
  regions: string[];
  years: number[];
}

interface FilterSidebarProps {
  genres: string[];
  regions: string[];
  years: number[];
  state: FilterState;
  onToggle: (group: keyof FilterState, value: string | number) => void;
  onReset: () => void;
  hasActive: boolean;
}

export default function FilterSidebar({ genres, regions, years, state, onToggle, onReset, hasActive }: FilterSidebarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
            <i className="ri-filter-3-line"></i>
          </span>
          <h3 className="font-heading font-bold text-foreground-950">筛选条件</h3>
        </div>
        {hasActive && (
          <button type="button" onClick={onReset} className="text-xs text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap">
            重置全部
          </button>
        )}
      </div>

      <FilterGroup title="题材类型" options={genres} selected={state.genres} onToggle={(v) => onToggle('genres', v)} />
      <FilterGroup title="地区" options={regions} selected={state.regions} onToggle={(v) => onToggle('regions', v)} />
      <FilterGroup title="年份" options={years} selected={state.years} onToggle={(v) => onToggle('years', v)} />
    </div>
  );
}